import { breakText, formatGameTime, getMatchDate } from '@sportal365/smp-widget-utils';
import { FC, useContext } from 'react';
import { SMPFlex } from '../../atoms/SMPFlex';
import { SMPText } from '../../atoms/SMPText';
import { ConfigContext } from '../../contexts/ConfigContext';

interface EventDateProps {
  startTime: string;
}

export const EventDate: FC<EventDateProps> = ({ startTime }) => {
  const { sdkOptions } = useContext(ConfigContext);

  const date = getMatchDate(startTime, sdkOptions, 'dd MMM').toUpperCase();
  const time = formatGameTime(startTime, sdkOptions);

  return (
    <SMPFlex className='date-and-status-wrapper' direction='column' align='center' justify='spaceEvenly' gap='sm' style={{ width: '50px' }}>
      <SMPFlex align='center'>
        <SMPText textAlign='center' size='2_5' variant='primaryGray'>
          {breakText(date)}
        </SMPText>
      </SMPFlex>
      <SMPText display='flex' variant='primaryGray' size='2_5' weight='400' style={{ justifyContent: 'unset' }}>
        {time}
      </SMPText>
    </SMPFlex>
  );
};
